// Required since mjml-core uses process.cwd() which is not available in the browser so we mock it here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(globalThis as any).process = {
  cwd: () => '/',
  env: {},
  platform: 'browser',
  version: '',
};

// Stub require.resolve for mjml-browser / emaileditor packages that use CJS require
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (typeof (globalThis as any).__require === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__require = Object.assign(
    (id: string) => { throw new Error(`Cannot require '${id}' in browser`); },
    { resolve: (id: string) => id },
  );
}
if (typeof (globalThis as any).require === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).require = Object.assign(
    (id: string) => { throw new Error(`Cannot require '${id}' in browser`); },
    { resolve: (id: string) => id },
  );
}

export {};
